var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2328 12.6075C27.2328 12.6234 27.2249 12.6368 27.2116 12.6421C25.1191 13.665 21.0482 15.3165 15.6841 15.3298C10.2457 15.3431 6.11908 13.6703 4.02124 12.6421C4.00797 12.6341 4 12.6208 4 12.6075V7.56766C4 7.53836 4.02655 7.51972 4.05311 7.53037C6.4696 8.48399 10.5033 9.73062 15.6177 9.73062C20.7322 9.73062 24.7632 8.48399 27.1824 7.53037C27.2089 7.51972 27.2355 7.53836 27.2355 7.56766V12.6075H27.2328Z",
    fill: "#90205D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2328 19.2493C27.2328 19.2653 27.2249 19.2786 27.2116 19.2866C25.1191 20.3095 21.0482 21.9583 15.6841 21.9743C10.2457 21.9876 6.12173 20.3148 4.02124 19.2866C4.00797 19.2786 4 19.2653 4 19.2493V14.2122C4 14.1829 4.02655 14.1642 4.05311 14.1749C6.4696 15.1285 10.5033 16.3751 15.6151 16.3751C20.7269 16.3751 24.7606 15.1285 27.1771 14.1749C27.2036 14.1642 27.2302 14.1856 27.2302 14.2122V19.2493H27.2328Z",
    fill: "#90205D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2328 26.7856C27.2328 26.799 27.2249 26.8123 27.2142 26.8203C25.1217 28.0323 21.0509 29.9821 15.6841 29.9981C10.243 30.0141 6.11642 28.0323 4.01859 26.8203C4.00531 26.8123 4 26.799 4 26.7856V20.8109C4 20.7816 4.02921 20.7629 4.05577 20.7736C6.47491 21.903 10.5059 23.3761 15.6177 23.3761C20.7295 23.3761 24.7606 21.903 27.1797 20.7736C27.2063 20.7603 27.2355 20.7816 27.2355 20.8109V26.7856H27.2328Z",
    fill: "#90205D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6151 8.69663C22.0299 8.69663 27.2302 7.19754 27.2302 5.34832C27.2302 3.49909 22.0299 2 15.6151 2C9.20025 2 4 3.49909 4 5.34832C4 7.19754 9.20025 8.69663 15.6151 8.69663Z",
    fill: "#90205D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.6e6e4cdd.svg";
export { ForwardRef as ReactComponent };